import { ICP_CANISTER_RE } from "./constants.js";
export function getIcpHost() {
    if (typeof window !== "undefined" && window.location.hostname.includes("localhost")) {
        return "http://localhost:4943";
    }
    return "https://icp0.io";
}
export async function createIcpAgent() {
    const { HttpAgent } = await import("@dfinity/agent");
    const host = getIcpHost();
    // Agent v3+: HttpAgent.create. v2: constructor (Bazaar still on 2.x).
    const create = HttpAgent.create;
    if (typeof create === "function") {
        return create.call(HttpAgent, { host });
    }
    return new HttpAgent({ host });
}
export function normalizeIcpCanisterId(raw) {
    const id = raw.trim().toLowerCase();
    return ICP_CANISTER_RE.test(id) ? id : null;
}
export { ICP_CANISTER_RE };
